var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('o-confirmation-view',{attrs:{"image":"images/vab-header.jpg","message":"Je bestelling is met succes geregistreerd. Je krijgt zo dadelijk een e-mail met meer informatie.","nav-bar-title":"VAB Assistance"}})}
var staticRenderFns = []

export { render, staticRenderFns }